import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';

function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data } = await api.post('/auth/login', form);
      localStorage.setItem('liceo_token', data.token);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.error || 'Error de conexión');
    }
    setLoading(false);
  };

  return (
    <div className="admin-login">
      <div className="admin-login-card">
        <h1>Panel Administrativo</h1>
        <p className="subtitle">Liceo Adolfo León Gómez</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Usuario</label>
            <input type="text" required value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} autoFocus />
          </div>
          <div className="form-group">
            <label>Contraseña</label>
            <input type="password" required value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
          </div>
          {error && <div className="form-error" style={{ marginBottom: '1rem' }}>{error}</div>}
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
